import { Input, InputProps } from 'modules/ui/atoms/Input'
import { useState, useEffect } from 'react'

const DollarInput = ({
  onChange,
  onBlur,
  onFocus,
  label,
  value,
  error,
  dataId,
  required,
  inputRef,
  hasCounter,
  maxLength,
  autoFocus,
}: InputProps) => {
  const [inputValue, setInputValue] = useState(value)
  const [hasFocus, setHasFocus] = useState(false)

  useEffect(() => {
    if (hasFocus) {
      return
    }

    const formatedNumber = formatCurrencyToNumber(String(value))
    const formatedCurrency = formatNumberToCurrency(formatedNumber)

    setInputValue(formatedCurrency)
  }, [value, hasFocus])

  const handleOnChange = (value: string) => {
    setInputValue(value)

    if (onChange) onChange(value)
  }

  const formatNumberToCurrency = (value: number) => {
    if (!value) {
      return ''
    }

    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  const formatCurrencyToNumber = (value: string) => {
    if (!value) {
      return 0
    }

    return typeof value === 'number'
      ? value
      : Number(value.replace('$', '').replace(/[^0-9.-]+/g, ''))
  }

  const handleOnBlur = () => {
    setHasFocus(false)

    const formatedNumber = formatCurrencyToNumber(value)
    const formatedCurrency = formatNumberToCurrency(formatedNumber)

    setInputValue(formatedCurrency)

    if (onBlur) onBlur()
    if (onChange) onChange(formatedCurrency)
  }

  const handleOnFocus = () => {
    setHasFocus(true)
    if (onFocus) onFocus()
  }

  return (
    <Input
      hasCounter={hasCounter}
      maxLength={maxLength}
      value={inputValue}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
      label={label}
      error={error}
      type="text"
      dataId={dataId}
      required={required}
      inputRef={inputRef}
      autoFocus={autoFocus}
    />
  )
}

export default DollarInput
